import _curry from "ramda/es/curry";
import _view from "ramda/es/view";
import _pipe from "ramda/es/pipe";
import mathMinSpread from './mathMinSpread';

var lensMin = function (lens, obj) {
  return _pipe(_view(lens), mathMinSpread)(obj);
};

export default _curry(lensMin);